var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "fusoLogo",
    width: "120.000000pt",
    height: "120.000000pt",
    viewBox: "0 0 1200.000000 1200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1200.000000)scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo",
    className: "logo",
    d: "M5817 11953 c-112 -182 -1496 -2600 -1493 -2607 3 -6 339 -589 748 -1296 l744 -1285 -1500 -5 -1500 -5 -748 -1295 c-411 -712 -748 -1298 -748 -1303 0 -4 678 -6 1506 -5 l1505 3 746 1292 c410 711 749 1291 752 1289 3 -2 341 -585 751 -1295 l745 -1290 1518 -1 c961 0 1517 4 1515 10 -1 5 -345 592 -763 1304 l-760 1296 -1497 0 c-824 0 -1498 2 -1498 4 0 2 336 586 746 1297 l746 1293 -18 36 c-45 89 -1479 2570 -1486 2570 -4 0 -9 -3 -11 -7z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "LetterO",
    d: "M10000 2379 c-463 -12 -659 -51 -794 -158 -126 -100 -185 -229 -218 -471 -17 -127 -17 -947 0 -1075 26 -198 65 -288 168 -391 120 -121 255 -170 529 -193 202 -17 918 -24 1260 -12 528 18 669 53 822 206 119 118 162 233 183 480 13 160 13 823 -1 961 -31 318 -103 455 -289 549 -156 79 -275 93 -900 105 -250 5 -462 9 -470 8 -8 -1 -139 -5 -290 -9z m1070 -519 c132 -16 189 -37 217 -79 52 -78 56 -110 61 -486 6 -529 -9 -613 -118 -667 -30 -15 -84 -32 -120 -38 -97 -17 -711 -24 -971 -11 -281 14 -370 25 -436 57 -44 21 -56 33 -78 79 -24 48 -28 71 -37 232 -6 98 -8 297 -5 443 7 307 15 356 70 407 54 49 122 64 335 73 245 11 961 4 1082 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "LetterF",
    d: "M40 1225 l0 -1135 295 0 295 0 0 415 0 415 898 2 897 3 3 238 2 237 -900 0 -900 0 0 220 0 220 950 0 950 0 0 260 0 260 -1245 0 -1245 0 0 -1135z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "LetterS",
    d: "M6310 2334 c-86 -18 -178 -65 -228 -114 -47 -47 -104 -154 -123 -230 -22 -85 -19 -521 4 -620 34 -152 110 -256 232 -317 112 -58 86 -56 930 -63 535 -4 788 -9 805 -17 14 -6 36 -23 50 -38 23 -24 25 -36 28 -129 4 -126 -10 -169 -62 -191 -30 -13 -178 -15 -1016 -15 l-980 0 0 -260 0 -260 993 0 c1041 0 1229 6 1339 40 150 46 269 185 315 367 26 101 26 486 0 595 -49 207 -165 324 -378 380 -82 21 -103 22 -834 27 -720 6 -751 7 -782 25 -42 26 -63 79 -63 161 0 87 22 138 68 162 35 17 90 18 980 21 l942 3 0 244 0 245 -1077 -1 c-887 0 -1090 -3 -1143 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "LetterU",
    d: "M2903 1478 c3 -606 8 -869 16 -908 61 -284 216 -440 496 -501 95 -21 128 -22 725 -26 656 -5 782 0 929 38 155 40 249 103 329 224 62 92 96 193 111 333 7 66 11 385 11 897 l0 795 -299 0 -300 0 -3 -777 c-4 -709 -5 -783 -21 -831 -22 -64 -69 -114 -127 -131 -61 -18 -307 -30 -625 -30 -411 -1 -524 16 -584 84 -56 64 -55 46 -59 898 l-3 787 -300 0 -300 0 4 -852z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuso);
export default __webpack_public_path__ + "static/media/fuso.73f3526d.svg";
export { ForwardRef as ReactComponent };